import { useState } from 'react';
import { NodeType } from '@flow-studio/types';

export type CurationKey = 'all' | 'frequent' | 'favorite' | 'topRated';

export interface CurationState {
  all: boolean;
  frequent: boolean;
  favorite: boolean;
  topRated: boolean;
}

const DEFAULT: CurationState = { all: true, frequent: false, favorite: false, topRated: false };

export function useCurationFilter() {
  const [curation, setCuration] = useState<CurationState>(DEFAULT);

  // Pressing any key clears all others — acts as an exclusive selection.
  // Pressing the already-active key resets to All.
  const toggleCuration = (key: CurationKey) => {
    setCuration(prev => {
      if (key === 'all' || prev[key]) return DEFAULT; // already selected → reset to All
      return { all: false, frequent: false, favorite: false, topRated: false, [key]: true };
    });
  };

  const matchesCuration = (nodeType: NodeType): boolean => {
    if (curation.all) return true;
    const nt = nodeType as any;
    return (
      (curation.frequent && !!nt.isFrequent) ||
      (curation.favorite && !!nt.isFavorite) ||
      (curation.topRated && !!nt.isTopRated)
    );
  };

  return { curation, toggleCuration, matchesCuration };
}
